import { Image } from './Image';

export const ABout: Image[] = [
  { src: '/assets/about/about-5.jpg'},
  { src: '/assets/about/about-4.jpg'},
  { src: '/assets/about/about-3.jpg'},
  { src: '/assets/about/about-2.jpg'},
  { src: '/assets/about/about-1.jpg'},
];
